export const allGreetings = [
  "Hello there!",
  "Hi!",
  "Good morning! Or evening. I don't know how to use watches...",
  "Well hello there!",
  "Hi again! Or hi for the first time! I have no idea.",
  "Good to see you!",
  "Nice to see you!",
  "Howdy!",
  "Hiya!",
  "Sup'!"
];
